import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Coins, Loader2 } from "lucide-react";
import { toast } from "sonner";

const BG = "https://images.unsplash.com/photo-1759545809864-f5f766827780?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export default function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(username, password);
    setLoading(false);
    if (!res.ok) toast.error(res.error);
  };

  return (
    <div className="min-h-screen flex bg-background">
      <div className="hidden lg:block relative w-1/2 grain overflow-hidden border-r border-border">
        <img src={BG} alt="coin city" className="absolute inset-0 h-full w-full object-cover opacity-70" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-[#0A0A0A]/40" />
        <div className="absolute bottom-10 left-10 right-10">
          <h2 className="font-head text-4xl font-black tracking-tight leading-tight">Coin Operations,<br />under control.</h2>
          <p className="text-muted-foreground mt-3 max-w-md">Monitor your coin-dispensing fleet in real time — connectivity, transactions, coin levels and alerts across every machine.</p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-2 mb-8">
            <div className="flex h-9 w-9 items-center justify-center rounded-sm bg-white text-black">
              <Coins className="h-5 w-5" />
            </div>
            <div>
              <div className="font-head font-black tracking-tight text-lg leading-none">PlayMint</div>
              <div className="text-[10px] text-muted-foreground uppercase tracking-widest">Coin Operations Portal</div>
            </div>
          </div>

          <h1 className="font-head text-2xl font-bold tracking-tight mb-1">Sign in</h1>
          <p className="text-sm text-muted-foreground mb-6">Admin & merchant access</p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs uppercase tracking-wider text-muted-foreground">Username</label>
              <input
                data-testid="login-username" value={username} onChange={(e) => setUsername(e.target.value)}
                autoFocus className="mt-1 w-full rounded-sm border border-input bg-[#141414] px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-white"
                placeholder="playmint"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-muted-foreground">Password</label>
              <input
                data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-1 w-full rounded-sm border border-input bg-[#141414] px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-white"
                placeholder="••••••••"
              />
            </div>
            <button
              data-testid="login-submit" disabled={loading}
              className="w-full flex items-center justify-center gap-2 rounded-sm bg-white text-black font-medium py-2.5 hover:bg-neutral-200 transition-colors disabled:opacity-60"
            >
              {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
            </button>
          </form>

          <div className="mt-8 text-xs text-muted-foreground border border-border rounded-sm p-3 bg-[#111]">
            <div className="font-medium text-foreground mb-1">Demo accounts</div>
            <div className="mono">admin · playmint / Playmint@2026</div>
            <div className="mono">merchant · skyline / Skyline@2026</div>
          </div>
        </div>
      </div>
    </div>
  );
}
